import React from "react";
import { Icon } from "@iconify/react";
import SessionRatingList from "../../components/Session/SessionRatingListComponent";
import SessionNotesList from "../../components/Session/SessionNotesListComponent";
import { formatDate, formatTime } from "../../helper/helper";

const SessionViewModal = ({ session }) => {

    const data = session || {};
    console.log("RAW DATE:", data.sessionDate);

    return (

        <div className="modal fade" id="viewSessionModal">

            <div className="modal-dialog modal-lg modal-dialog-centered">

                <div className="modal-content radius-16">

                    <div className="modal-header border-0">
                        <h5 className="fw-bold">Session Details</h5>

                        <button
                            className="btn-close"
                            data-bs-dismiss="modal"
                        />
                    </div>

                    <div className="modal-body">

                        <span className="badge bg-warning text-dark px-16 py-6 radius-20 mb-16">
                            {data.category}
                        </span>

                        <h6 className="fw-semibold mb-16">
                            {data.title}
                        </h6>

                        <div className="d-flex align-items-center gap-24 text-secondary mb-8">

                            <div className="d-flex align-items-center gap-8">
                                <Icon icon="mdi:clock-outline" />
                                <span>
                                    {formatTime(data.startTime)} – {formatTime(data.endTime)} · {formatDate(data.sessionDate)}
                                </span>
                            </div>

                        </div>

                        <div className="d-flex align-items-center gap-8 text-secondary mb-20">
                            <Icon icon="mdi:map-marker-outline" />
                            <span>
                                {data.room} · {data.eventLocation?.name}
                            </span>
                        </div>

                        {/* ACTION BUTTONS */}

                        {/* <div className="border rounded-12 p-16 d-flex justify-content-around mb-24">

                            <div className="text-center">

                                <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-6"
                                    style={{ width: 45, height: 45 }}>
                                    <Icon icon="mdi:bookmark-outline" />
                                </div>

                                <p className="text-sm mb-0">Save</p>

                            </div>

                            <div className="text-center">

                                <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-6"
                                    style={{ width: 45, height: 45 }}>
                                    <Icon icon="mdi:share-variant" />
                                </div>

                                <p className="text-sm mb-0">Share</p>

                            </div>

                            <div className="text-center">

                                <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-6"
                                    style={{ width: 45, height: 45 }}>
                                    <Icon icon="mdi:star-outline" />
                                </div>

                                <p className="text-sm mb-0">Rate</p>

                            </div>

                        </div> */}

                        <h6 className="fw-semibold mb-12">
                            About this session
                        </h6>

                        <div
                            className="text-secondary mb-24"
                            dangerouslySetInnerHTML={{ __html: data.description }}
                        />

                        {data.speakers?.length > 0 && (

                            <div>

                                <h6 className="fw-semibold mb-16">
                                    Speakers
                                </h6>

                                {data.speakers.map((sp) => (

                                    <div
                                        key={sp.id}
                                        className="border rounded-12 p-12 mb-12 d-flex align-items-center justify-content-between"
                                    >

                                        <div className="d-flex align-items-center gap-12">

                                            <img
                                                src={
                                                    sp.profilePicture
                                                        ? `${process.env.REACT_APP_API_URL}/${sp.profilePicture}`
                                                        : "/assets/images/user.png"
                                                }
                                                alt=""
                                                className="rounded-circle"
                                                style={{ width: 45, height: 45, objectFit: "cover" }}
                                            />

                                            <div>

                                                <div className="fw-semibold">
                                                    {sp.fullName}
                                                </div>

                                                <div className="text-secondary text-sm">
                                                    {sp.Company?.designation || "Speaker"}
                                                </div>

                                            </div>

                                        </div>

                                        <Icon icon="mdi:chevron-right" />

                                    </div>

                                ))}

                            </div>

                        )}

                        {/* ================= Session Ratings & Notes ================= */}

                        <div className="row mt-24">

                            <div className="col-md-12">
                                <SessionRatingList sessionId={data.id} />
                            </div>

                            {/* <div className="col-md-6">
                                <SessionNotesList sessionId={data.id} />
                            </div> */}

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default SessionViewModal;
